module.exports = __webpack_public_path__ + "public/img/vertical_logo.97349670.svg";